<template>
	<b-modal ref="modal" title="Floor Plan" style="height: 85vh; width: 80%;" hide-footer>
	<b-container fluid class="p-0">
	  <iframe
		:src="(event.floor_plan_link || event.floor_plan)"
		style="width: 100%; height: 95vh; border: none;"
		allowfullscreen
		webkitallowfullscreen
		mozallowfullscreen
		></iframe>
	</b-container>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalFloorPlan',
  props: {
	event: {
	  type: Object,
	  required: true,
	},
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  /deep/ .modal-dialog {
    width: 80%;
    height: 85vh;
    max-width: unset !important;
  }
}

</style>